export const RECIPE_NODE_TEMPLATE_TYPE = {
  Page: 'PAGE',
};
